import { $Representation, $GenderDto, type GenderDto, type Representation } from '@eneco/dc-be/client';

const genderMale = $GenderDto.enum[1];
const genderFemale = $GenderDto.enum[2];

export const representationMr = $Representation.enum[0];
const representationMrs = $Representation.enum[1];

export const genderToRepresentation = (gender: GenderDto | undefined): Representation | undefined => {
  if (!gender) return undefined;
  if (gender === genderMale) return representationMr;
  if (gender === genderFemale) return representationMrs;
  return undefined;
};

export const representationToGender = (representation: Representation | undefined): GenderDto | undefined => {
  if (!representation) return undefined;
  if (representation === representationMr) return genderMale;
  if (representation === representationMrs) return genderFemale;
  return undefined;
};
